import { pprops } from '@frontend/sports/common/core/utils/redux';
import { NativePrice } from '@frontend/sports/odds/feature/native-price';
import { createAction, props } from '@ngrx/store';

import BetslipActions from '../../base/store/actions';
import { BetBuilderPickId } from '../../core/picks/pick-id';
import { IBetBuilderPickState } from './models';

export interface ISportcastOption {
    name: string;
    longId: string;
}

export interface IRequestBetBuilderPricePayload {
    pickId: BetBuilderPickId;
    eventId: string;
    sportId: number;
    externalFixtureId: number;
    betgeniusId: number;
    useV2Key: boolean;
    sportcastOptions: ISportcastOption[];
    stake: number;
    isInit?: boolean;
}

export interface IUpdateBetBuilderPickPayload {
    pickId: BetBuilderPickId;
    eventId: string;
    sportId: number;
    sportcastOptions: ISportcastOption[];
    //TODO try to replace native price with Odds
    price: NativePrice;
}

export interface IIncorrectSelectionPayload {
    pickId: BetBuilderPickId;
    eventId: string;
    sportcastOption: ISportcastOption;
}

export default class BetbuilderActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/bet-builder`;

    private static readonly REQUEST_BET_BUILDER_PRICE = `${BetbuilderActions.ACTION_SCHEMA}/REQUEST_PRICE`;
    private static readonly UPDATE_BET_BUILDER_PICK = `${BetbuilderActions.ACTION_SCHEMA}/UPDATE_BET_BUILDER_PICK`;
    private static readonly REMOVE_INCORRECT_SELECTION = `${BetbuilderActions.ACTION_SCHEMA}/REMOVE_INCORRECT_SELECTION`;
    private static readonly DISPLAY_ERROR_MESSAGE = `${BetbuilderActions.ACTION_SCHEMA}/DISPLAY_ERROR_MESSAGE`;
    private static readonly ADD_PICK = `${BetbuilderActions.ACTION_SCHEMA}/ADD_PICK`;
    private static readonly REMOVE_PICK = `${BetbuilderActions.ACTION_SCHEMA}/REMOVE_PICK`;
    private static readonly SET_PICK_STAKE = `${BetbuilderActions.ACTION_SCHEMA}/SET_PICK_STAKE`;
    private static readonly SET_PICK_STAKES = `${BetbuilderActions.ACTION_SCHEMA}/SET_PICK_STAKES`;
    private static readonly SET_PICK_REWARD_TOKEN = `${BetbuilderActions.ACTION_SCHEMA}/SET_PICK_REWARD_TOKEN`;
    private static readonly REMOVE_ALL_PICK_REWARD_TOKENS = `${BetbuilderActions.ACTION_SCHEMA}/REMOVE_ALL_PICK_REWARD_TOKENS`;

    static requestBetBuilderPrice = createAction(BetbuilderActions.REQUEST_BET_BUILDER_PRICE, pprops<IRequestBetBuilderPricePayload>());
    static updateBetBuilderPick = createAction(BetbuilderActions.UPDATE_BET_BUILDER_PICK, pprops<IUpdateBetBuilderPickPayload>());
    static removeIncorrectSelection = createAction(BetbuilderActions.REMOVE_INCORRECT_SELECTION, props<IIncorrectSelectionPayload>());
    static displayErrorMessage = createAction(BetbuilderActions.DISPLAY_ERROR_MESSAGE, props<{ message: string }>());
    static addPick = createAction(
        BetbuilderActions.ADD_PICK,
        props<{
            pickId: string;
            pickState: Partial<IBetBuilderPickState>;
        }>(),
    );

    static removePick = createAction(BetbuilderActions.REMOVE_PICK, props<{ pickId: string }>());
    static setPickStake = createAction(
        BetbuilderActions.SET_PICK_STAKE,
        props<{ pickId: string; stake: number | null; silent?: boolean; stakeStr?: string }>(),
    );

    static setPickStakes = createAction(BetbuilderActions.SET_PICK_STAKES, props<{ stake: number | null; silent?: boolean; stakeStr?: string }>());

    static setPickRewardToken = createAction(
        BetbuilderActions.SET_PICK_REWARD_TOKEN,
        props<{
            pickId: string;
            rewardTokenId: string | null;
        }>(),
    );

    static removeAllPickRewardTokens = createAction(BetbuilderActions.REMOVE_ALL_PICK_REWARD_TOKENS);
}
